import { ProductStockStatus } from '@/fo/api/magento';
import { UiKitLabelBrand } from '@/fo/ui/kit/label/brand';
import { staticMediaUrl } from '@/fo/util/image-loader';
import { MappedProduct } from '@/fo/util/map-product-data';

export const productMock: MappedProduct = {
  sku: '123456',
  mindboxId: '1234',
  name: 'Масло для душа',
  brand: 'Bioderma',
  series: 'Atoderm',
  shortDescription: 'Увлажняющее масло для душа для всей семьи',
  thumbnail: {
    src: staticMediaUrl('product/bioderma.png'),
    alt: 'Масло для душа'
  },
  stockStatus: ProductStockStatus.InStock,
  stockQuantity: 10,
  basePrice: 3199,
  finalPrice: 2600,
  bonusPoints: 99,
  bonusPointsMax: 99,
  labelsBonus: [{ name: 'Повышенный кэшбэк' }],
  labelsBrand: [{ name: 'Bioderma', color: '#003a70', url: '/bioderma' }],
  labels: [{ name: 'Хит' }],
  structureImage: null,
  mediaGallery: [],
  rating: 4.5,
  reviewCount: 10,
  bestRating: 5,
  worstRating: 1,
  earnedBonusPoints: 99,
  effects: 'Увлажнение',
  benefits:
    '⭐ Рекомендовано дерматологами. ❤ Бонусы и подарки при каждой покупке. ✅ Отзывы, цены и акции на сайте.',
  description_html: 'Увлажняющее масло для душа для всей семьи',
  characteristics: [],
  activeComponents: [],
  composition: 'Увлажняющее масло для душа для всей семьи',
  usageInstructions: 'Увлажняющее масло для душа для всей семьи',
  configurableVariants: [
    {
      sku: '1',
      label: '1 л',
      stockStatus: ProductStockStatus.InStock,
      isSelected: true
    },
    {
      sku: '2',
      label: '200 мл',
      stockStatus: ProductStockStatus.InStock,
      isSelected: false
    },
    {
      sku: '3',
      label: '100 мл',
      stockStatus: ProductStockStatus.OutOfStock,
      isSelected: false
    }
  ],
  brandCode: 'bioderma',
  catalogBrandUrl: '/bioderma',
  subtitle: 'Увлажняющее масло для душа для всей семьи',
  link: '/product/123456',
  firstLevelCategory: null,
  lastLevelCategory: null,
  baseImage: null
};

const labels = [
  {
    name: 'Bioderma',
    color: '#003a70',
    url: '/bioderma'
  },
  {
    name: 'Atoderm',
    color: '#0077cf',
    url: '/atoderm'
  }
];

export const labelsMock = labels.map(({ name, color, url }) => (
  <UiKitLabelBrand
    key={name}
    url={url}
    color={color}
  >
    {name}
  </UiKitLabelBrand>
));
